module.exports = __webpack_public_path__ + "img/Skirt-Front-B1-Da-Fb-Ga-Hc-Ia.c272f499.png";